import { Collection, CollectionTarget } from "@ciaopeople/cp-shatsu/DomHelper";
import { DomHelper as D } from "@ciaopeople/cp-shatsu/DomHelper";
import { UserActionIdentifier } from "../../api/commondata/UserActionError.js";
import { ContentRestrictionCriteria } from "../../api/types/NotificationDataTypes.js";
import { inEnum, isBoolean, isFunction, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { validMailCheck } from "@api-commons/utils/MailVaildation.js";

const READY_ATTR = "data-fpready";
const PARSED_ATTR = "data-sdkparsed";
const UMEDIUM_ATTR = "data-umedium";
const USOURCE_ATTR = "data-usource";
const RESTICTION_CRITERIA = "data-reqmem";
const SUBSCRIPTION_ONLY_ATTR = "data-subscription-only"
const REDIRECT_URL_ATTR = "data-redirect-url";
const TOPIC_LABEL_ATTR = "data-topic-label";


export interface SubscriptionCallbackUserInfo {

    id?: string,
    first_name?: string,
    last_name?: string,
    email?: string,
    
}

export function isSubscriptionCallbackUserInfo(x: any): x is SubscriptionCallbackUserInfo {
    return  isObject(x) &&
            ((("id" in x) && isString(x.id) && x.id.trim() != "") || 
                (("email" in x) && isString(x.email) && validMailCheck(x.email))) &&
            (!("first_name" in x) || isString(x.first_name) || !x.first_name) &&
            (!("last_name" in x) || isString(x.last_name) || !x.last_name);
        
}



export interface SubscriptionCallbackData {

    topic_label?: string,
    subscription_intent: boolean,
    is_subscription_changed?: boolean,
    redirect_url?: string
    user: SubscriptionCallbackUserInfo
    user_was_already_registered: boolean
}


export function isSubscriptionCallbackData(x: any): x is SubscriptionCallbackData {
    return  isObject(x) &&
            (!("topic_id" in x) || isString(x.topic_id)) &&
            (!("topic_label" in x) || isString(x.topic_label)) &&
            (("subscription_intent" in x) && isBoolean(x.subscription_intent)) &&
            (!("redirect_url" in x) || isString(x.redirect_url)) &&
            (("user" in x) && isSubscriptionCallbackUserInfo(x.user));
}
export abstract class SdkHandledHTMLElement <StatusData> extends Collection {


    constructor(private target: HTMLElement) {
        const el = D(target);
        super(el.isMultiple()?el.first():el); 
    }
 
    public setParsed(): SdkHandledHTMLElement<StatusData> {
        this.attr(PARSED_ATTR, "true");
        return this;
    }

    public isAlreadyParsed(): boolean {
        const ratt = this.firstAttr(PARSED_ATTR);
        return ratt && ratt == "true";
    }

    public isSubscriptionOnly(): boolean {
        const ratt = this.firstAttr(SUBSCRIPTION_ONLY_ATTR);
        return ratt && ratt == "1";
    }
    
    public setReady(): SdkHandledHTMLElement<StatusData> {
        this.attr(READY_ATTR, "true");
        return this;
    }


    public getRedirectUrl(): string | null {
        const ratt = this.firstAttr(REDIRECT_URL_ATTR)?.trim();
        return ratt && ratt != ""?ratt:null;
    }

    public isReady(): boolean {
        const ratt = this.firstAttr(READY_ATTR);
        return ratt && ratt == "true";
    }

    public getUTMmedium(): string {
        return this.firstAttr(UMEDIUM_ATTR);
    }

    public getTopicLabel(): string {
        const ratt = this.firstAttr(TOPIC_LABEL_ATTR)?.trim();
        return ratt && ratt != ""?ratt:null;
    }

    public getUTMSource(): string {
        return this.firstAttr(USOURCE_ATTR);
    }

    public getAssociatedUserAction(): UserActionIdentifier {
        return UserActionIdentifier.GENERIC_CALL;
    }

    public getContentRestrictionCriteria(): ContentRestrictionCriteria {
        const ratt = this.firstAttr(RESTICTION_CRITERIA);
        return (ratt && inEnum(ratt,ContentRestrictionCriteria)?ratt:ContentRestrictionCriteria.ACCESSIBLE_TO_ALL);
    }


    public setContentRestrictionCriteria(criteria?: ContentRestrictionCriteria): SdkHandledHTMLElement<StatusData> {
        this.attr(RESTICTION_CRITERIA, criteria?criteria:ContentRestrictionCriteria.ACCESSIBLE_TO_ALL);
        return this;
    }
    public abstract setStatus(s: StatusData): SdkHandledHTMLElement<StatusData>;
    public abstract getStatus(): StatusData;

    public executeAfterSubscriptionCallback(data: SubscriptionCallbackData): void {
        if (("_afterSubscriptionCallback" in this.target) &&
            isFunction(this.target._afterSubscriptionCallback)) {
                this.target._afterSubscriptionCallback(data);
        }
    }

    public hasExecuteAfterSubscriptionCallback(): boolean {
        return ("_afterSubscriptionCallback" in this.target) &&
            isFunction(this.target._afterSubscriptionCallback);
    }


    
}